export default "__VITE_ASSET__FdF$hUNH__"